
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SurveyRuleActionValidationError {
  export enum SurveyRuleActionValidationError {
    INVALID_SKIP_TO_TARGET_COUNT = "INVALID_SKIP_TO_TARGET_COUNT",
    INVALID_TARGET = "INVALID_TARGET",
    INVALID_ACTION_GROUP_CHILD = "INVALID_ACTION_GROUP_CHILD",
    INVALID_TARGET_GRID_ROW = "INVALID_TARGET_GRID_ROW",
    INVALID_ACTION_GRID_ROW = "INVALID_ACTION_GRID_ROW",
    INVALID_ACTION_RESPONDENT = "INVALID_ACTION_RESPONDENT",
    INVALID_ACTION_MULTI_CHOICE = "INVALID_ACTION_MULTI_CHOICE",
    INVALID_KEY_TARGET_ORDER = "INVALID_KEY_TARGET_ORDER",
  }

  export interface SurveyRuleActionValidationErrorDTO {
    case: string;
  }

  export const fromDTO = (dto: SurveyRuleActionValidationErrorDTO): SurveyRuleActionValidationError => {
    if (dto === undefined || dto === null) {
      throw new InvalidSurveyRuleActionValidationErrorError(
        `Invalid DTO ${dto} provided for SurveyRuleActionValidationError.SurveyRuleActionValidationError`
      );
    }
    switch (dto.case) {
      case "INVALID_SKIP_TO_TARGET_COUNT":
        return SurveyRuleActionValidationError.INVALID_SKIP_TO_TARGET_COUNT;
      case "INVALID_TARGET":
        return SurveyRuleActionValidationError.INVALID_TARGET;
      case "INVALID_ACTION_GROUP_CHILD":
        return SurveyRuleActionValidationError.INVALID_ACTION_GROUP_CHILD;
      case "INVALID_TARGET_GRID_ROW":
        return SurveyRuleActionValidationError.INVALID_TARGET_GRID_ROW;
      case "INVALID_ACTION_GRID_ROW":
        return SurveyRuleActionValidationError.INVALID_ACTION_GRID_ROW;
      case "INVALID_ACTION_RESPONDENT":
        return SurveyRuleActionValidationError.INVALID_ACTION_RESPONDENT;
      case "INVALID_ACTION_MULTI_CHOICE":
        return SurveyRuleActionValidationError.INVALID_ACTION_MULTI_CHOICE;
      case "INVALID_KEY_TARGET_ORDER":
        return SurveyRuleActionValidationError.INVALID_KEY_TARGET_ORDER;
      default:
        throw new InvalidSurveyRuleActionValidationErrorError(
          `Case ${dto.case} is not valid case of SurveyRuleActionValidationError.SurveyRuleActionValidationError`
        );
    }
  };

  export const toDTO = (surveyRuleActionValidationError: SurveyRuleActionValidationError): SurveyRuleActionValidationErrorDTO => {
    const enumDTO = {
      case: SurveyRuleActionValidationError[surveyRuleActionValidationError],
    };
    return enumDTO;
  };
}

export class InvalidSurveyRuleActionValidationErrorError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorError";
  }
}
export class InvalidSurveyRuleActionValidationErrorInvalidSkipToTargetCountError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidSkipToTargetCountError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidTargetError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidTargetError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidActionGroupChildError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidActionGroupChildError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidTargetGridRowError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidTargetGridRowError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidActionGridRowError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidActionGridRowError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidActionRespondentError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidActionRespondentError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidActionMultiChoiceError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidActionMultiChoiceError";
  }
}

export class InvalidSurveyRuleActionValidationErrorInvalidKeyTargetOrderError extends InvalidSurveyRuleActionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleActionValidationErrorInvalidKeyTargetOrderError";
  }
}
